import './App.css';
import {
  RouterProvider,
} from "react-router-dom"
import "@fontsource/poppins";
import "@fontsource/playfair-display";
import "@fontsource-variable/reddit-sans";
import 'katex/dist/katex.min.css';
import React from 'react';
import ToastContext, { ToastContextProps } from './contexts/ToastContext';
import { router } from './routes';
import MyStatusBar from './components/MyStatusBar';
import LoadingScreen from './components/LoadingScreen';
import LoadingContext from './contexts/LoadingContext';
import { GameSocketProvider } from './providers/gameSocket.provider';

function App(){

  const [successOpen, setSuccessOpen] = React.useState<boolean>(false);
  const [successMessage, setSuccessMessage] = React.useState<string>('');
  const [errorOpen, setErrorOpen] = React.useState<boolean>(false);
  const [errorMessage, setErrorMessage] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  const handleSuccessclose = ()=>{
    setSuccessOpen(false);
  }
  const handleErrorclose = ()=>{
    setErrorOpen(false);
  }

  // Context values
  const toastValue: ToastContextProps = {
    openSuccess: (message)=>{
      setSuccessMessage(message);
      setSuccessOpen(true);
    },

    openError: (message)=>{
      setErrorMessage(message);
      setErrorOpen(true);
    },
  }

  return (
    <GameSocketProvider>
      <ToastContext.Provider value={toastValue}>
        <MyStatusBar
          successOpen={successOpen} successMessage={successMessage} 
          onSuccessClose={handleSuccessclose}
          errOpen={errorOpen} errMessage={errorMessage} 
          onErrClose={handleErrorclose}
        />
        {loading && <LoadingScreen/>}
        <LoadingContext.Provider value={{ loading, setLoading }}>
          <RouterProvider router={router} />
        </LoadingContext.Provider>
      </ToastContext.Provider>
    </GameSocketProvider>
  );
}

export default App;
